<template>
  <div class="text-echarts">
    <v-chart :autoresize="true" :option="option"></v-chart>
  </div>
</template>
<script>
export default {
  name: "text-echarts",

  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      option: {
        tooltip: {
          trigger: "axis",
        },
        axisPointer: [
          {
            name: "邮件营销",
            type: "line",
            data: [120, 132, 101, 134, 90, 230, 210],
          },
        ],
      },
    };
  },
  watch: {
    data() {
      //监听数据改变时
      this.option.series[0].data = this.data;
    },
  },
  mounted() {
    this.init();
    console.log(this.option.series[0].data, "this.option.series[0].data");
  },
  methods: {
    init() {
      this.option = {
        xAxis: {
          type: "category",
          data: [
            "1日",
            "2日",
            "3日",
            "4日",
            "5日",
            "6日",
            "7日",
            "8日",
            "9日",
            "10日",
            "11日",
            "12日",
            "13日",
            "14日",
            "15日"
          ],
        },
        yAxis: {
          type: "value",
        },
        tooltip: {
          trigger: "axis",
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        series: [
          {
            data: this.data,
            type: "line",
          },
        ],
      };
    },
  },
};
</script>
<style scoped>
span {
  display: flex;
  justify-content: center;
  font-size: 20px;
}
.text-echarts {
  background-color: #ffff;
  height: 567px;
}
</style>



// WEBPACK FOOTER //
// src/views/home/text-echartsTwo.vue